var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3982 36.1382V14.1529H3.0971V36.1382H10.399H10.3982ZM6.74917 11.1516C9.29468 11.1516 10.8794 9.46344 10.8794 7.35365C10.8318 5.19578 9.29468 3.55469 6.79758 3.55469C4.29876 3.55469 2.66675 5.19578 2.66675 7.35345C2.66675 9.46325 4.25093 11.1515 6.70133 11.1515H6.7486L6.74917 11.1516ZM14.4394 36.1382H21.74V23.8619C21.74 23.2057 21.7876 22.5478 21.9805 22.0791C22.508 20.7657 23.7093 19.4062 25.7267 19.4062C28.3679 19.4062 29.4251 21.4221 29.4251 24.3779V36.1382H36.7254V23.5325C36.7254 16.7798 33.124 13.6374 28.3206 13.6374C24.3825 13.6374 22.6529 15.8405 21.6919 17.341H21.7405V14.1536H14.4398C14.5351 16.2161 14.4393 36.1389 14.4393 36.1389L14.4394 36.1382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.1ea47a6a697647e9052e7b719e3011e2.svg";
export { ForwardRef as ReactComponent };